export default[
    {
        path:'/success',
        meta:{
            title:'success',
        },
        component: resolve => require(['@/statepayment/views/success.vue'], resolve)
    },
    {
        path:'/fail',
        meta:{
            title:'fail',
        },
        component: resolve => require(['@/statepayment/views/fail.vue'], resolve)
    },
    {
        path:'/en/success',
        meta:{
            title:'success',
        },
        component: resolve => require(['@/statepayment/views/en/success.vue'], resolve)
    },
    {
        path:'/en/fail',
        meta:{
            title:'fail',
        },
        component: resolve => require(['@/statepayment/views/en/fail.vue'], resolve)
    },
]



// WEBPACK FOOTER //
// ./src/statepayment/router/router.js